import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { Router } from '@angular/router';


@Injectable()


export class AuthenticationInterceptor implements HttpInterceptor {

    constructor( 
        private authService: AuthenticationService,
        private router: Router,
    ) { }



    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // No need to execute this api call as this interceptor is already doing this
        if (request.url === this.authService.authConfig?.renewSessionApiUrl) {
            return next.handle(request);
        }
        // If it is part of protected/scope URL then
        if (
            this.authService.authConfig?.apiUrl &&
            request.url.indexOf(this.authService.authConfig.apiUrl) >= 0 
        ) {
            // Set header on all request
            request = request.clone({
                withCredentials: true,
            });
            return next.handle(request).pipe(
                map(response => this.handleRequestResponse(response)),
                catchError(error => this.handleRequestError(error))
            );
        }
        return next.handle(request);
    }





    private handleRequestResponse(response: any) {  
        // Update Active Session Time
        this.authService.setActiveSessionTimer();
        return response;
    }



    private handleRequestError(err: any): Observable<any> {

        //handle your auth error or rethrow
        // Send All errors
        this.authService.OnErrorCatcher.next(err);

        // Handle 401 errors
        if (err instanceof HttpErrorResponse && err.status === 401) {

            // App Mandatory Session Expired (user should loggout from the app)
            if (
                err.error.reason.toLowerCase() === "mandatorysessionexpired" ||
                err.statusText.toLowerCase() === "mandatorysessionexpired"
            ) {
                this.authService.logout();
                return throwError(err);
            }

            // App session expired
            else if (
                err.error.reason.toLowerCase() === "appsessionexpired" ||
                err.statusText.toLowerCase() === "appsessionexpired"
            ) {
                this.authService.activeSessionIsValid.next(false);
                // Redirect to session expired route
                if(this.authService.authConfig?.sessionExpiredRoutePath){
                    this.router.navigate([this.authService.authConfig?.sessionExpiredRoutePath]);
                }
                return throwError(err);
            }


            // User unauthorized
            else if (
                (err.error.reason.toLowerCase() === "unauthorized" ||
                    err.statusText.toLowerCase() === "unauthorized") 
            ) {
                // Redirect to un-authorized route
                if(this.authService.authConfig?.unAuthorizedRoutePath){
                    this.router.navigate([this.authService.authConfig?.unAuthorizedRoutePath]);
                }
                return throwError(err);
            }

        }

        if (err instanceof HttpErrorResponse && err.status === 403) {
            this.router.navigate(['no-access']);
        }
        return throwError(err);
    }

}